export default __webpack_public_path__ + "static/media/branched.8f292873.svg";